var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChocolate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 512,
      width: 512
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.385 64.965s-17.449 15.537-26.69 12.29c-3.338-1.172-6.104-4.45-8.353-8.49L244.398 85.71l84.582 84.584 60.258-60.258-14.955-14.955c-3.33 1.341-6.57 2.1-9.422 1.842-10.105-.913-23.527-19.315-23.527-19.315S325.559 92.59 316.4 90.602c-10.594-2.3-20.015-25.637-20.015-25.637zm-64.713 33.47-60.254 60.256L256 243.273l60.254-60.253zm170.293 24.327-60.258 60.258 84.584 84.582 60.256-60.256zM158.69 171.418l-44.802 44.803 100.488 68.675L243.273 256zm170.29 24.328L268.726 256l84.582 84.582 60.255-60.254zM78.491 213.828 48.848 278.02l85.732.11 48.123 93.856 72.02-17.418 49.988 79.266 29.115-45.504zM256 268.727l-26.504 26.503 100.488 68.676 10.598-10.597zM34.107 296l-8.654 8.654 181.893 181.893 67.047-67.047-28-44.4-73.239 17.712-49.58-96.697L34.777 296z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChocolate);
export default __webpack_public_path__ + "static/media/chocolate.8c864d2fc98b8e28a34614395cd03b30.svg";
export { ForwardRef as ReactComponent };